import '../App.css';
import { useEffect, useState } from "react";
import Swal from 'sweetalert2';
import CartTotal from './CartTotal';
import Footer from './Footer';
import Header from './Header';
import HeaderPrincipal from './Principal/HeaderPrincipal';
import ProgressCheckout from './ProgressCheckout';


function Carrito(){

    const [carrito, setCarrito] = useState([]);
    let ppp = []

    let p1 = 1;

    const eliminarProducto=(id)=>{
        Swal.fire({
            title: 'Estas segura/o?',
            text: "",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, eliminar!'
          }).then((result) => {
            if (result.isConfirmed) {
              Swal.fire(
                'Eliminado!',
                'Su articulo a sido eliminado.',
                'success'
              )
                const newList = carrito.filter((e, index) => index !== id);
                setCarrito(newList)
                localStorage.setItem('Registrados', JSON.stringify(newList))
            }else if(result.dismiss){
                Swal.fire(
                    'Cancelado',
                    'Tu articulo está a salvo :)',
                    'error'
                )
            }
        })
    }

    const eliminarCarrito=()=>{
        Swal.fire({
            title: 'Estas segura/o?',
            text: "Una vez presiones accetar no hay vuelta atras!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, eliminar!'
        }).then((result) => {
            if (result.isConfirmed) {
              Swal.fire(
                'Eliminado!',
                'Su articulo a sido eliminado.',
                'success'
              )
                localStorage.clear()
                setCarrito(ppp)
            }
        })
    }


    useEffect(()=>{
        const storeProductos = JSON.parse(localStorage.getItem('Registrados'));
        if(storeProductos){
          setCarrito(storeProductos);
        }
      }
    ,[])


    let total=0;

    const sumall = carrito.map(item => item.Price);
    sumall.forEach(function(a){total+=a;});

    const nuevoPrecio = Number(total);

    return(
        <>
            <Header num={sumall.length}/>
            {/* <HeaderPrincipal cart={sumall.length}/> */}

            <div className="container-progress-checkout">
                <ProgressCheckout estilo={p1}/>
            </div>

            <div className="container-tablas-productos">
                <section>
                <table>
                    <thead>
                        <tr className='encabezado'>
                            <th scope="col">Producto</th>
                            <th scope="col"></th>
                            <th scope="col">Cantidad</th>
                            <th scope="col">Precio</th>
                            <th className='th-eliminar' scope="col">
                                <img title='Vaciar todo' onClick={()=> eliminarCarrito()} src={require('../assets/images/eliminar.png')} alt="" />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {carrito.map((c, index)=>{
                            return(
                                <tr>
                                    <td align='center'>
                                        <figure>
                                            <img className='td-img' src={c.Image} alt="" />
                                        </figure>
                                    </td>
                                    <td className='td-titulo'>{c.Title}</td>
                                    <td className='td-cantidad'>
                                        <span className='disminuir'>-</span>
                                        <span className='cantidad'>1</span>
                                        <span className='aumentar'>+</span>
                                    </td>
                                    <td className='td-precio'>RD$ {c.Price}</td>
                                    <td className='td-eliminar' title='Quitar del carrito'>
                                        <img onClick={()=> eliminarProducto(index)} src={require('../assets/images/eliminar.png')} alt="" />
                                    </td>
                                </tr>
                            )
                        })}
                        
                    </tbody>
                </table>
                </section>

                <CartTotal Total={nuevoPrecio}/>

            </div>
            
            <Footer/>

        </>
    )
}

export default Carrito;